import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { MODAL_HORIZONTAL_PADDING } from '../../constants/modalHorizontalPadding'
import * as ModalStyled from '../ModalBody/styles'

export const ModalNavigationWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${Spacing.S12} ${MODAL_HORIZONTAL_PADDING} 0;

  + ${() => ModalStyled.ModalBodyWrapper} {
    padding-top: ${Spacing.S24};
  }
`
